import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { breakpoints } from '@/styles'
import useMediaQuery from '@/hooks/use-media-query'
import { Article } from '@/features/About'

import {
  bcBusiness,
  bcBusinessMobile,
  businessInVancouver,
  businessInVancouverMobile,
  canadaNewsMedia,
  canadaNewsMediaMobile,
  dailyHive,
  dailyHiveMobile,
  vancouverIsAwesome,
  vancouverIsAwesomeMobile,
  vancouverSun,
  vancouverSunMobile
} from './logos'

const Grid = styled.div`
  padding-bottom: 110px;
  display: grid;
  grid-template-columns: 375px 375px 375px;
  grid-auto-rows: 200px;
  gap: 5px 5px;
  justify-content: center;

  @media only screen and (max-width: 1250px) {
    grid-template-columns: 30% 30% 30%;
  }

  @media only screen and (max-width: ${breakpoints.ipadMiniMax}) {
    padding-bottom: 80px;
    grid-template-columns: 45% 45%;
    grid-auto-rows: 150px;
    gap: 3px;
  }

  @media only screen and (max-width: ${breakpoints.phoneMax}) {
    grid-template-columns: 160px 160px;
    grid-auto-rows: 100px;
    gap: 3px;
  }
`

const AsSeenIn = () => {
  const { t } = useTranslation('about')
  const displayMobile = useMediaQuery(
    `(max-width: ${breakpoints.tabletLandscape})`
  )
  return (
    <Grid>
      <Article
        wide
        name={t('about:Vancouver Sun')}
        logo={displayMobile ? vancouverSunMobile.src : vancouverSun.src}
        link="https://vancouversun.com/sponsored/news-sponsored/tenants-and-landlords-choosing-digital-contact-free-ways-to-secure-rentals"
      />
      <Article
        wide
        name={t('about:Daily Hive')}
        logo={displayMobile ? dailyHiveMobile.src : dailyHive.src}
        link={[
          'https://dailyhive.com/vancouver/liv-rent-app-renting-vancouver-process-simple-safe',
          'https://dailyhive.com/vancouver/liv-rent-vancouver-app-rental-process',
          'https://dailyhive.com/toronto/rent-prices-drop-gta-regions-may'
        ]}
      />
      <Article
        wide
        name={t('about:Vancouver is Awesome')}
        logo={
          displayMobile ? vancouverIsAwesomeMobile.src : vancouverIsAwesome.src
        }
        link="https://www.vancouverisawesome.com/sponsored/apartment-listing-vancouver-live-rent-app-1940209"
      />
      <Article
        name={t('about:Canada News Media')}
        logo={displayMobile ? canadaNewsMediaMobile.src : canadaNewsMedia.src}
        link="https://canadanewsmedia.ca/how-canadas-real-estate-market-has-been-forced-to-move-online-urbanized-daily-hive/"
      />
      <Article
        wide
        name={t('about:BCBusiness')}
        logo={displayMobile ? bcBusinessMobile.src : bcBusiness.src}
        link="https://www.bcbusiness.ca/Matrix-6-BC-companies-at-the-forefront-of-property-tech"
      />
      <Article
        wide
        name={t('about:Business in Vancouver')}
        logo={
          displayMobile
            ? businessInVancouverMobile.src
            : businessInVancouver.src
        }
        link="https://biv.com/video/coping-covid-19-new-reality-renting"
      />
    </Grid>
  )
}

export default AsSeenIn
